function singlePubRoutes($stateProvider, moment) {
  $stateProvider
    .state('publications.publication', {
      abstract: true,
      url: '/:publicationId?starting&editionTime',
      params: {
        starting: {
          type: 'int',
          value: moment().unix(),
          dynamic: true
        },
        editionTime: {
          dynamic: true
        }
      },
      template: '<div ui-view></div>',
      resolve: {
        distributors: [
          'distributorService',
          distributorService => distributorService.getByType('distributors')
        ],
        publication: [
          'Publication',
          '$transition$',
          (Publication, $transition$) => Publication.get($transition$.params().publicationId)
            .then(result => result, err => err)
        ],
        sets: [
          'Publication',
          Publication => Publication.getSets().then(sets => sets && sets.map)
        ],
        $state: [
          '$state',
          $state => $state
        ],
        $transitions: [
          '$transitions',
          $transitions => $transitions
        ]
      }
    })
    .state('publications.publication.editions', {
      url: '/editions?pubSections',
      params: {
        pubSections: {
          dynamic: true,
          array: true
        }
      },
      component: 'publicationContainer',
      data: {
        pageTitle: {
          de: 'Printkanal',
          en: 'Publication',
          es: 'Publicación',
          fr: 'Publication'
        }
      }
    })
    .state('publications.publication.section', {
      url: '/section/:sectionId',
      component: 'publicationContainer',
      data: {
        pageTitle: {
          de: 'Ressort',
          en: 'Section',
          es: 'Sección',
          fr: 'Section'
        }
      }
    });
}

export default function (ngModule) {
  ngModule.config([
    '$stateProvider',
    'moment',
    singlePubRoutes
  ]);
}
